import { gql } from '@apollo/client';

export const UPDATE_PRAYER_MEETING = gql`
    mutation UpdatePrayerMeeting($id: Int!, $supportedOrganisationId: Int!, $name: String, $location: String, $time: String, $frequency: String) {
        updatePrayerMeeting(id: $id, supportedOrganisationId: $supportedOrganisationId, name: $name, location: $location, time: $time, frequency: $frequency) {
            id
            name
            location
            time
            frequency
        }
    }
`;
